/* src/app/modules/accounting/reports/sumasysaldos/accounting-sumasysaldos.component.css */
.ss-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 100%;
  box-sizing: border-box;
}
.ss-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.ss-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ss-header__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(227, 253, 100, .12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ss-header__icon mat-icon {
  color: var(--cf-brand-dark);
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.ss-header__title {
  margin: 0 0 2px;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}
.ss-header__sub {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}
.ss-header__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.ss-btn-export {
  border-radius: 10px !important;
  font-size: 13px !important;
  gap: 6px;
  color: #475569 !important;
}
.ss-btn-export mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.ss-btn-export:disabled {
  opacity: 0.45;
}
.ss-filters {
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}
.ss-filters__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.ss-field {
  flex: 1;
  min-width: 140px;
  max-width: 180px;
}
:host ::ng-deep .ss-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.ss-toggle {
  align-self: center;
}
.ss-btn-primary {
  background: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  white-space: nowrap;
  gap: 6px;
}
.ss-btn-primary mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ss-groups {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 10px;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
}
.ss-groups__label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #64748b;
  white-space: nowrap;
}
.ss-groups__checks {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}
.ss-group-check {
  background: #f8fafc;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
  transition: background 0.15s;
}
.ss-group-check--all {
  border-color: rgba(227, 253, 100, 0.35);
  background: rgba(227, 253, 100, 0.06);
}
.ss-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 60px 24px;
  color: #94a3b8;
  text-align: center;
}
.ss-empty mat-icon {
  font-size: 52px;
  width: 52px;
  height: 52px;
  opacity: .3;
}
.ss-empty p {
  margin: 0;
  font-size: 15px;
  color: #475569;
}
.ss-table-wrap {
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}
.ss-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
}
.ss-th {
  padding: 10px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  white-space: nowrap;
}
.ss-th--account {
  width: 76px;
}
.ss-th--title {
  width: 220px;
}
.ss-th--num {
  width: 90px;
  text-align: right;
}
.ss-row {
  transition: background 0.1s;
}
.ss-row:hover {
  background: rgba(227, 253, 100, 0.04) !important;
}
.ss-row--even {
  background: #fafbfc;
}
.ss-td {
  padding: 7px 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  color: #1e293b;
  vertical-align: middle;
}
.ss-td--account {
  font-variant-numeric: tabular-nums;
}
.ss-td--title {
  color: #334155;
  font-size: 12.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 0;
}
.ss-td--num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ss-td--red {
  color: #dc2626;
}
.ss-account-num {
  display: inline-block;
  font-weight: 600;
  color: #e3fd64;
  letter-spacing: .01em;
}
.hover-ledger .ss-account-num:hover {
  text-decoration: underline;
}
.ss-tfoot-total,
.ss-tfoot-saldo {
  background: #f1f5f9;
}
.ss-tfoot-total .ss-td,
.ss-tfoot-saldo .ss-td {
  border-top: 2px solid rgba(148, 163, 184, 0.25);
  border-bottom: none;
  padding: 8px 10px;
}
.ss-td--footer-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #475569;
}
@media (max-width: 767px) {
  .ss-page {
    padding: 12px;
    gap: 14px;
  }
  .ss-filters__row {
    flex-direction: column;
    align-items: stretch;
  }
  .ss-field {
    max-width: none;
  }
  .ss-table-wrap {
    overflow-x: auto;
  }
  .ss-table {
    min-width: 600px;
  }
}
/*# sourceMappingURL=accounting-sumasysaldos.component.css.map */
